import "@fortawesome/free-brands-svg-icons";

import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  fetchUpdatedShippingTypeRates,
  saveShipping,
  setData,
  loadedPage,
  setFieldInformation,
  setFieldShipping,
  getPickupPriceOld,
} from "../actions/checkoutStore";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Alert from "./Alert";
import DOMPurify from "dompurify";
import Header from "./Header";
import { Link } from "react-router-dom";
import LoadingIcon from "../components/LoadingIcon";
import MapLocationDrag from "./MapLocationDrag";
import NavigationFooter from "./NavigationFooter";
import ShippingDateTimeField from "./custom_fields/ShippingDateTimeField";
import Select from "react-select";
import ShowOrderSummary from "./ShowOrderSummary";
import { closeAlertMessage } from "../redux/ui";
import { useTranslation } from "react-i18next";
import { X } from "@phosphor-icons/react";

const ShippingContent = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const { t } = useTranslation();

  const [error, setError] = useState("");

  const { information, shipping, summary, urls, colors } = state.checkoutStore;

  const { isLoading, doingRequest, alertMessage } = state.ui;

  const [errorDiv, setErrorDiv] = useState(null);

  const [enabledMovePin, setEnabledMovePin] = useState(false);

  const isFirstRun = useRef(true);

  const [isLoadingMap, setIsLoadingMap] = useState(false);

  const [available_shipping_methods, setAvailableShippingMethods] = useState(
    [],
  );
  const timeDebounce = 500;

  useEffect(() => {
    const filteredShippingMethods = shipping.shipping_methods.filter(
      (sm) =>
        (!sm.table.error || sm.table.shipping_method_type == "pedidos_ya") &&
        (!sm.table.same_day_delivery ||
          (sm.table.same_day_delivery &&
            ((information.coordinates != null &&
              information.coordinates.length > 0) ||
              sm.table.shipping_method_type == "pedidos_ya"))),
    );
    setAvailableShippingMethods(filteredShippingMethods);
  }, [shipping.shipping_methods, information.coordinates]);

  useEffect(() => {
    if (isFirstRun.current) {
      dispatch(loadedPage("shipping"));
      isFirstRun.current = false;
    }

    setIsLoadingMap(true);
    const timer = setTimeout(() => {
      setIsLoadingMap(false);
    }, timeDebounce);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (errorDiv != null && shipping.error != "") errorDiv.scrollIntoView();
  }, [errorDiv]);

  useEffect(() => {
    if (
      shipping.available_shipping_method_types.length ==
        shipping.loaded_shipping_types.length &&
      shipping.shipping_methods.length == 1
    ) {
      const shippingNames =
        shipping.shipping_methods[0].table.shipping_method_name +
        "," +
        (shipping.shipping_methods[0].table.shipping_service_name == null
          ? ""
          : shipping.shipping_methods[0].table.shipping_service_name);

      const methodValue =
        shipping.shipping_methods[0].table.shipping_method_id +
        "," +
        (shipping.shipping_methods[0].table.shipping_service_id == null
          ? ""
          : shipping.shipping_methods[0].table.shipping_service_id) +
        (shipping.shipping_methods[0].table.rate_id
          ? "," + shipping.shipping_methods[0].table.rate_id
          : "");
      changeMethodsFields(methodValue, shippingNames);
    }
  }, [shipping.loaded_shipping_types, shipping.shipping_methods]);

  const errorMsgCallback = useCallback((node) => {
    if (node !== null) {
      setErrorDiv(node);
    }
  }, []);

  useEffect(() => {
    if (
      shipping.shipping_ids.shipping_method_id == null ||
      summary.update_shipping == false
    )
      return;
    for (let i = 0; i < shipping.shipping_methods.length; i++) {
      if (
        shipping.shipping_ids.shipping_method_id ===
          shipping.shipping_methods[i].table.shipping_method_id &&
        shipping.shipping_ids.shipping_service_id ===
          shipping.shipping_methods[i].table.shipping_service_id
      ) {
        const methodValue =
          shipping.shipping_methods[i].table.shipping_method_id +
          "," +
          (shipping.shipping_methods[i].table.shipping_service_id == null
            ? ""
            : shipping.shipping_methods[i].table.shipping_service_id) +
          (shipping.shipping_methods[i].table.rate_id
            ? "," + shipping.shipping_methods[i].table.rate_id
            : "");
        const shippingNames =
          shipping.shipping_methods[i].table.shipping_method_name +
          "," +
          (shipping.shipping_methods[i].table.shipping_service_name == null
            ? ""
            : shipping.shipping_methods[i].table.shipping_service_name);
        changeMethodsFields(methodValue, shippingNames, true);
      }
    }
    dispatch(
      setData({
        ...state.checkoutStore,
        summary: {
          update_shipping: false,
        },
      }),
    );
  }, [summary.update_shipping]);

  const getRateId = (shippingMethodId) => {
    const shippingMethod = shipping.shipping_methods.find((sm) => {
      return sm.table.shipping_method_id == shippingMethodId;
    });

    return shippingMethod.table.rate_id;
  };

  const getRateDescription = (shippingMethodId) => {
    const shippingMethod = shipping.shipping_methods.find((sm) => {
      return sm.table.shipping_method_id == shippingMethodId;
    });

    return shippingMethod.table.rate_description;
  };

  const getPrice = (shippingMethodId) => {
    const shippingMethod = shipping.shipping_methods.find((sm) => {
      return sm.table.shipping_method_id == shippingMethodId;
    });

    return shippingMethod.table.price_unformatted;
  };

  const defaultColor = "#929292";

  const customStyles = () => ({
    control: (base) => ({
      ...base,
      borderRadius: "6px",
      height: "44px",
      padding: "0 8px",
      fontSize: "14px",
      border: "",
      backgroundColor: "white",
    }),
    placeholder: (base) => ({
      ...base,
      color: defaultColor,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: defaultColor,
      padding: "8px",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({
      ...base,
      padding: "4px 8px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? defaultColor
        : state.isFocused
          ? "#f0f0f0"
          : "#fff",
      color: state.isSelected ? colors.text_color : "#000",
      padding: "8px 12px",
      cursor: "pointer",
    }),
  });

  const changeStoreField = (field, value) => {
    dispatch(setFieldShipping(field, value));
  };

  const changeStoreInformationField = (field, value) => {
    dispatch(setFieldInformation(field, value));
  };

  const changeCoordinates = (field, value) => {
    changeStoreInformationField(field, value);

    axios({
      headers: {
        common: {
          "Content-Type": "application/json",
        },
      },
      method: "put",
      url: urls.update_coordinates,
      data: {
        coordinates: value,
      },
      params: { recover_token: window.token },
    }).then((response) => {
      if (currentShippingService.table.shipping_method_type === "pedidos_ya") {
        dispatch(fetchUpdatedShippingTypeRates("pedidos_ya"));
      }
      changeStoreInformationField("address", response.data.address);
      changeStoreInformationField("city", response.data.city);
      changeStoreInformationField("municipality", response.data.municipality);
      changeStoreInformationField("complement", response.data.complement);
      changeStoreInformationField("postal", response.data.postal);
      if (currentShippingService.table.shipping_method_type === "tables") {
        dispatch(fetchUpdatedShippingTypeRates("tables"));
      }
    });
  };

  const currentShippingService = shipping.shipping_methods.find((sm) => {
    return (
      (sm.table.shipping_method_id ==
        shipping.shipping_ids.shipping_method_id &&
        !sm.table.shipping_service_id) ||
      (sm.table.shipping_method_id ==
        shipping.shipping_ids.shipping_method_id &&
        sm.table.shipping_service_id ==
          shipping.shipping_ids.shipping_service_id)
    );
  });

  const changeMethodsFields = (
    shipping_ids,
    shipping_names,
    firstLoad = false,
  ) => {
    setEnabledMovePin(false);
    var split = shipping_ids.split(",");
    var ids = {
      shipping_method_id: split[0],
      shipping_service_id: split[1],
      rate_id: split[2],
    };
    ids.shipping_service_id =
      ids.shipping_service_id == "" ? null : ids.shipping_service_id;
    split = shipping_names.split(",");
    var names = {
      shipping_method_name: split[0],
      shipping_service_name: split[1],
    };
    names.shipping_service_name =
      names.shipping_service_name == "" ? null : names.shipping_service_name;
    const currentShippingService = shipping.shipping_methods.find((sm) => {
      return (
        (sm.table.shipping_method_id == ids.shipping_method_id &&
          !sm.table.shipping_service_id) ||
        (sm.table.shipping_method_id == ids.shipping_method_id &&
          sm.table.shipping_service_id == ids.shipping_service_id)
      );
    });

    const hasBranches =
      currentShippingService.table.branches &&
      currentShippingService.table.branches.length > 0;
    let branchId = null;
    let branchName = null;

    if (hasBranches) {
      branchId = currentShippingService.table.branches[0].value;
      branchName = branchId
        ? currentShippingService.table.branches[0].label
        : null;
      if (firstLoad)
        dispatch(
          getPickupPriceOld(
            currentShippingService.table.branches[0].value,
            currentShippingService.table.branches[0].label,
            currentShippingService.table.shipping_method_type,
            information.country,
            information.region,
            information.municipality,
            information.postal,
          ),
        );
    }

    const shippingData = {
      shipping: {
        shipping_ids: ids,
        shipping_names: names,
        branch_id: branchId,
        branch_name: branchName,
        delivery_price: getPrice(ids.shipping_method_id),
      },
    };
    dispatch(setData(shippingData));

    ids.branch_id = branchId;
    ids.branch_name = branchName;

    saveData(false, ids);
  };

  const updateBranchFields = (row, service_type) => {
    const branchData = {
      shipping: {
        branch_id: row.value,
        branch_name: row.label,
        pickup_price: null,
      },
    };

    dispatch(setData(branchData));
    dispatch(
      getPickupPriceOld(
        row.value,
        row.label,
        service_type,
        information.country,
        information.region,
        information.municipality,
        information.postal,
      ),
    );
  };

  const validate = (ids = null) => {
    var formIsValid = true;

    if (ids != null) {
      return formIsValid;
    }

    if (information.shipping_option === "delivery") {
      if (
        !shipping.shipping_ids.shipping_method_id &&
        !shipping.shipping_ids.shipping_service_id
      ) {
        formIsValid = false;
        setError(t("shipping.select-a-method"));
      }
    } else {
      if (!shipping.pickup_point_id) {
        formIsValid = false;
        setError(t("shipping.choose-a-place"));
      }
    }

    return formIsValid;
  };

  const removeError = () => {
    setError("");
  };

  const saveData = (goToNextScreen = true, ids = null) => {
    if (doingRequest || !validate(ids)) {
      return;
    }

    changeStoreField("error", "");
    removeError();

    let url = "";
    let params = {};
    if (information.shipping_option === "delivery") {
      url = urls.save_shipping;
      url += "&goToNextScreen=" + (goToNextScreen ? true : false);
      if (ids) {
        params = {
          shipping: {
            shipping_method_id: ids.shipping_method_id,
            shipping_service_id: ids.shipping_service_id,
            rate_id: ids.rate_id,
            rate_description: getRateDescription(ids.shipping_method_id),
            delivery_price: getPrice(ids.shipping_method_id),
            address: information.address,
            branch_id: ids.branch_id,
            branch_name: ids.branch_name,
            coordinates: information.coordinates,
            country: information.country,
            region: information.region,
            municipality: information.municipality,
          },
        };
      } else {
        params = {
          shipping: {
            shipping_method_id: shipping.shipping_ids.shipping_method_id,
            shipping_service_id: shipping.shipping_ids.shipping_service_id,
            rate_id: shipping.shipping_ids.rate_id
              ? shipping.shipping_ids.rate_id
              : getRateId(shipping.shipping_ids.shipping_method_id),
            rate_description: getRateDescription(
              shipping.shipping_ids.shipping_method_id,
            ),
            delivery_price: getPrice(shipping.shipping_ids.shipping_method_id),
            address: information.address,
            branch_id: shipping.branch_id,
            branch_name: shipping.branch_name,
            date: shipping.date?.toLocaleString() ?? null,
            coordinates: information.coordinates,
          },
        };
      }
    } else if (information.shipping_option === "store_pickup") {
      url = urls.save_shipping_pickup;
      params = {
        shipping: {
          pickup_point_id: shipping.pickup_point_id,
          pickup_point_name: shipping.pickup_point_name,
          name: information.name,
          surname: information.surname,
        },
      };
    } else if (information.shipping_option === "point_pickup") {
      url = urls.save_shipping_point_pickup;
      params = {
        shipping: {
          branch_id: shipping.branch_id,
          branch_name: shipping.branch_name,
          shipping_branch_address: shipping.shipping_branch_address,
          shipping_method_id: shipping.shipping_ids.shipping_method_id,
          shipping_service_id: shipping.shipping_ids.shipping_service_id,
          name: information.name,
          surname: information.surname,
          municipality: shipping.selected_branch.municipality_code,
          region: shipping.selected_branch.region_code,
          address: shipping.shipping_branch_address,
          country: shipping.selected_branch.country,
        },
      };
    }

    dispatch(saveShipping(url, params, navigate));
  };

  const errorMessage = () => {
    return (
      <div className="error-message ms-3 me-3">
        <div className="message-div">
          <span>{error}</span>
        </div>
        <button
          disabled={doingRequest}
          id="alert-button-close"
          className="btn btn-close-error"
          onClick={() => removeError(error)}
          style={{
            backgroundColor: colors.main_color,
            color: colors.text_color,
          }}
        >
          <X className="fas" size={24} weight="light" />
        </button>
      </div>
    );
  };

  const shippingAddress = [
    information.address,
    information.complement,
    information.postal,
    shipping.municipality || information.city,
    shipping.region,
    shipping.country,
  ]
    .filter((x) => x)
    .join(", ");

  const Information = (
    <Fragment>
      <div className="col-12">
        <h5>{t("shipping.order-information")}</h5>
      </div>

      <div className="col-12">
        <div className="row g-sm-3">
          <div className="col-sm-6 mb-3">
            <div className="order-information-div p-3">
              <div className="separatedContent">
                <h6>{t("payment.contact")}</h6>
                <Link
                  rel="noopener noreferrer"
                  className="small"
                  to={urls.information || "/#"}
                  style={{ color: colors.main_color }}
                >
                  {t("payment.edit")}
                </Link>
              </div>
              <span>{information.email}</span>
            </div>
          </div>
          {(information.shipping_option === "delivery" ||
            information.shipping_option === "point_pickup") && (
            <div className="col-sm-6 mb-3">
              <div className="order-information-div p-3">
                <div className="separatedContent">
                  <h6>{t("payment.ship-to")}</h6>
                  <Link
                    rel="noopener noreferrer"
                    className="small"
                    to={urls.information || "/#"}
                    style={{ color: colors.main_color }}
                  >
                    {t("payment.edit")}
                  </Link>
                </div>
                <span>
                  {shipping.branch_name
                    ? shipping.branch_name
                    : shippingAddress}
                </span>
              </div>
            </div>
          )}
          {information.shipping_option === "store_pickup" && (
            <div className="col-sm-6 mb-3">
              <div className="order-information-div p-3">
                <div className="separatedContent">
                  <div
                    className="checkout-sub-section-title"
                    style={{ paddingBottom: "8px" }}
                  >
                    {t("information.who-pick-up")}
                  </div>
                  <Link
                    rel="noopener noreferrer"
                    className="small"
                    to={urls.information}
                    style={{ color: colors.main_color }}
                  >
                    {t("payment.edit")}
                  </Link>
                </div>
                <span>
                  {information.name}&nbsp;{information.surname}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );

  const NoShippingMethods = (
    <div className={`shippingBox col-12`} style={{ fontSize: "14px" }}>
      <span id="no-shipping">{t("shipping.no-shipping-methods")}</span>
    </div>
  );

  const AddressNotSet = (
    <div className={`shippingBox col-12`} style={{ fontSize: "14px" }}>
      <span id="no-shipping">{t("shipping.no-address-set")}</span>
    </div>
  );

  const groupStyles = {
    paddingLeft: "13px",
    marginBottom: "0.5em",
    fontWeight: "bold",
  };

  const GroupHeading = () => (
    <div style={groupStyles}>
      <span>{t("shipping.pickup-options")}</span>
    </div>
  );

  const main_color = "#424242";
  const default_border = "#929292";

  const selectedMethodIndex = available_shipping_methods.findIndex(
    (method) =>
      method.table.shipping_method_id ===
        shipping.shipping_ids.shipping_method_id &&
      method.table.shipping_service_id ===
        shipping.shipping_ids.shipping_service_id,
  );

  const ShippingMethod = (
    <Fragment>
      <div className="col-12">
        <div
          className="checkout-sub-section-title"
          style={{ paddingBottom: "16px" }}
        >
          {t("shipping.shipping-methods")}
        </div>
      </div>
      {error !== "" && errorMessage()}
      <div
        className={`shippingBox col-12 ${
          error != "" ? "error-div-highlight" : ""
        }`}
      >
        {shipping.shipping_methods &&
          available_shipping_methods.map((shipping_method, i) => {
            const selectedMethod =
              shipping.shipping_ids.shipping_method_id ==
                shipping_method.table.shipping_method_id &&
              shipping.shipping_ids.shipping_service_id ==
                shipping_method.table.shipping_service_id;
            const isNextMethod = i === selectedMethodIndex + 1;
            const methodOptionClass =
              available_shipping_methods.length === 1
                ? "10px 10px 10px 10px"
                : i === available_shipping_methods.length - 1
                  ? "0 0 10px 10px"
                  : available_shipping_methods.length > 1 && i === 0
                    ? "10px 10px 0 0"
                    : "";
            const methodValue =
              shipping_method.table.shipping_method_id +
              "," +
              (shipping_method.table.shipping_service_id == null
                ? ""
                : shipping_method.table.shipping_service_id) +
              (shipping_method.table.rate_id
                ? "," + shipping_method.table.rate_id
                : "");
            const shippingNames =
              shipping_method.table.shipping_method_name +
              "," +
              (shipping_method.table.shipping_service_name == null
                ? ""
                : shipping_method.table.shipping_service_name);

            const textToUseInEstimatedDeliveryDateRange =
              shipping_method.table.estimated_delivery_date &&
              shipping_method.table.estimated_delivery_date.includes(" - ")
                ? t("shipping.estimated_delivery_date_between")
                : t("shipping.estimated_delivery_date");
            return (
              <div
                key={shipping_method.table.id}
                className="shipping-names-div"
                tabIndex="0"
              >
                <div
                  className={`radioShippingLabel
                     ${selectedMethod ? "" : "disabled-shipping-method"}`}
                  style={{
                    borderTop: selectedMethod
                      ? `1px solid ${main_color}`
                      : isNextMethod && i != 0
                        ? ""
                        : `1px solid ${default_border}`,
                    borderLeft: selectedMethod
                      ? `1px solid ${main_color}`
                      : `1px solid ${default_border}`,
                    borderRight: selectedMethod
                      ? `1px solid ${main_color}`
                      : `1px solid ${default_border}`,
                    borderBottom: selectedMethod
                      ? `1px solid ${main_color}`
                      : available_shipping_methods.length === i + 1 &&
                          !selectedMethod
                        ? `1px solid ${default_border}`
                        : "",
                    borderRadius: `${methodOptionClass}`,
                  }}
                  onClick={() => {
                    if (!selectedMethod && !shipping_method.table.error) {
                      changeMethodsFields(methodValue, shippingNames);
                    }
                  }}
                >
                  <div
                    className="radioShippingDivTexts"
                    style={{
                      backgroundColor: selectedMethod ? "#FCFCFC" : "#FFFFFF",
                      color: "#424242",
                    }}
                  >
                    <div className="shipping-text-and-radio">
                      <input
                        className="radioOp"
                        style={{
                          accentColor: colors.main_color,
                          colorScheme: "light",
                        }}
                        type="radio"
                        disabled={doingRequest || shipping_method.table.error}
                        id={"radio_shipping_method_" + shipping_method.table.id}
                        value={methodValue}
                        checked={selectedMethod}
                        onChange={(e) => {
                          changeMethodsFields(e.target.value, shippingNames);
                        }}
                      />
                      <div
                        className="shipping-option-span"
                        style={{ color: "#505050" }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                          }}
                        >
                          {shipping_method.table.shipping_service_name
                            ? shipping_method.table.shipping_service_name
                            : shipping_method.table.shipping_method_name}
                          {shipping_method.table.same_day_delivery &&
                            t("shipping.courier-delivery")}
                        </span>
                        {shipping_method.table.estimated_delivery_date &&
                        information.store_country == "CL" &&
                        information.show_estimate_dates == 1 ? (
                          <span
                            style={{
                              fontWeight: "400",
                            }}
                            className="estimate-delivery-date"
                          >
                            {textToUseInEstimatedDeliveryDateRange +
                              " " +
                              shipping_method.table.estimated_delivery_date}
                          </span>
                        ) : (
                          shipping_method.table.show_range_estimate_dates ==
                            1 && (
                            <span
                              style={{
                                fontWeight: "400",
                              }}
                              className="estimate-delivery-date"
                            >
                              {textToUseInEstimatedDeliveryDateRange +
                                " " +
                                shipping_method.table.estimated_delivery_date}
                            </span>
                          )
                        )}
                        {selectedMethod &&
                          shipping_method.table.same_day_delivery &&
                          shipping_method.table.delivery_time && (
                            <Fragment>
                              <span
                                style={{
                                  fontWeight: "400",
                                }}
                                className="shipping-same-day-delivery"
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    t("shipping.same-day-delivery", {
                                      time: shipping_method.table.delivery_time,
                                    }),
                                  ),
                                }}
                              />
                            </Fragment>
                          )}

                        {selectedMethod &&
                          shipping_method.table.branches &&
                          shipping_method.table.branches.length > 0 &&
                          !information.new_pickup_map && (
                            <div className="floating-label-wrap mt-2">
                              <div>
                                <Select
                                  styles={customStyles}
                                  classNamePrefix="custom-select"
                                  id={`branch-office-${i}`}
                                  menuPosition="fixed"
                                  components={{ GroupHeading }}
                                  options={shipping_method.table.branches}
                                  onChange={(row) =>
                                    updateBranchFields(
                                      row,
                                      shipping_method.table
                                        .shipping_method_type,
                                    )
                                  }
                                  value={shipping_method.table.branches.find(
                                    (current) =>
                                      current.value === shipping.branch_id,
                                  )}
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <span
                      className="span-price"
                      style={{
                        color: "#424242",
                      }}
                    >
                      {shipping_method.table.error ? (
                        <span title={shipping_method.table.error_message}>
                          {t("shipping.service-unavailable")}
                          {shipping_method.table.error_message ===
                          "WAYPOINTS_OUT_OF_ZONE" ? (
                            <span>
                              {" - " +
                                t("shipping.service-waypoint-out-of-zone")}
                            </span>
                          ) : (
                            shipping_method.table.error_message ===
                              "MAX_DISTANCE_EXCEEDED" && (
                              <span>
                                {" - " +
                                  t("shipping.service-max-distance-exceeded")}
                              </span>
                            )
                          )}
                        </span>
                      ) : shipping_method.table.price === 0 ? (
                        t("summary.free-shipping")
                      ) : selectedMethod &&
                        shipping_method.table.branches &&
                        shipping_method.table.branches.length > 0 &&
                        shipping_method.table.shipping_method_type !=
                          "starken" &&
                        shipping.pickup_price == null &&
                        shipping.branch_id != null ? (
                        <LoadingIcon />
                      ) : selectedMethod &&
                        shipping.branch_id != null &&
                        shipping.pickup_price != null ? (
                        shipping.pickup_price
                      ) : shipping_method.table.price !=
                          summary.shipping_discount &&
                        summary.raw_shipping_discount != 0 &&
                        selectedMethod ? (
                        <div>
                          <s>{shipping_method.table.price}</s>{" "}
                          {summary.raw_shipping == summary.raw_shipping_discount
                            ? t("summary.free-shipping")
                            : summary.shipping_discount}
                        </div>
                      ) : shipping_method.table.price_unformatted == 0 &&
                        shipping_method.table.shipping_method_type !=
                          "cash_on_delivery" ? (
                        t("summary.free-shipping")
                      ) : (
                        shipping_method.table.price
                      )}
                    </span>
                  </div>
                  {selectedMethod &&
                    (shipping_method.table.same_day_delivery ||
                      shipping_method.table.shipping_method_type ===
                        "pedidos_ya") &&
                    information.coordinates != null &&
                    information.coordinates.length > 0 && (
                      <div
                        className="shippingMap"
                        style={{ position: "relative" }}
                      >
                        {!isLoadingMap && (
                          <MapLocationDrag
                            center={information.coordinates}
                            firstCoordinates={information.first_coordinates}
                            setCoordinates={changeCoordinates}
                            enabledMovePin={enabledMovePin}
                            setEnabledMovePin={setEnabledMovePin}
                          />
                        )}
                        {isLoadingMap && (
                          <LoadingIcon
                            style={{ height: "100%", alignItems: "center" }}
                          />
                        )}
                      </div>
                    )}
                  {selectedMethod &&
                    shipping_method.table.order_schedule &&
                    (shipping_method.table.order_schedule.scheduling_values_date
                      .length > 0 ||
                      shipping_method.table.order_schedule
                        .scheduling_values_weekly.length > 0 ||
                      shipping_method.table.order_schedule
                        .scheduling_values_order.length > 0) && (
                      <div className="">
                        <div>
                          <ShippingDateTimeField
                            shippingMethod={shipping_method.table}
                          />
                        </div>
                      </div>
                    )}
                  {selectedMethod &&
                    shipping_method.table?.custom_description &&
                    (shipping_method.table.custom_description !== undefined ||
                      shipping_method.table.custom_description !== "") && (
                      <Fragment>
                        <div
                          className="shipping-description d-none py-3 px-5 d-sm-block"
                          style={{
                            fontSize: "14px",
                            color: "#505050",
                            backgroundColor: "white",
                            borderTop: `1px solid #F5F5F5`,
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html:
                                shipping_method.table.custom_description.replace(
                                  /<\/?p>/g,
                                  "",
                                ),
                            }}
                          />
                        </div>
                        <div
                          className="d-flex flex-row w-100 d-sm-none py-3 px-5 shipping-description"
                          style={{
                            fontSize: "14px",
                            color: "#505050",
                            backgroundColor: "white",
                            borderTop: `1px solid #F5F5F5`,
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html:
                                shipping_method.table.custom_description.replace(
                                  /<\/?p>/g,
                                  "",
                                ),
                            }}
                          />
                        </div>
                      </Fragment>
                    )}
                </div>
              </div>
            );
          })}
      </div>
      {shipping.available_shipping_method_types &&
        information.shipping_option === "delivery" &&
        shipping.available_shipping_method_types.length !==
          shipping.loaded_shipping_types.length &&
        information.address != "" &&
        information.country != "" &&
        information.region != "" && (
          <div className="col-12 text-center pt-3 pb-3">
            <LoadingIcon textInside={true} text={t("shipping.loading-rates")} />
          </div>
        )}
      {shipping.available_shipping_method_types &&
        information.shipping_option === "delivery" &&
        shipping.available_shipping_method_types.length ===
          shipping.loaded_shipping_types.length &&
        shipping.shipping_methods.length === 0 &&
        information.address != "" &&
        information.country != "" &&
        information.region != "" &&
        NoShippingMethods}
      {shipping.shipping_methods.length != 0 &&
        shipping.shipping_methods.every(
          (method) => method.table.same_day_delivery === true,
        ) &&
        shipping.available_shipping_method_types.length ===
          shipping.loaded_shipping_types.length &&
        information.coordinates.length == 0 &&
        NoShippingMethods}
      {(information.address == "" ||
        information.country == "" ||
        information.region == "") &&
        shipping.loaded_shipping_types.length == 0 &&
        AddressNotSet}
    </Fragment>
  );

  if (isLoading || Object.keys(shipping).length === 0) {
    return <LoadingIcon default />;
  }

  if (props.vertical)
    return (
      <div id="shipping-page" className="row my-4">
        {information.shipping_option === "delivery" && ShippingMethod}
      </div>
    );

  return (
    <div id="shipping-page" className="row">
      {information.is_mobile && (
        <ShowOrderSummary
          is_mobile={information.is_mobile}
          type="shipping"
          toggleSummary={changeStoreInformationField}
        />
      )}
      <Header page="2" />
      {alertMessage != null && alertMessage.active && (
        <div className="col-12" ref={errorMsgCallback}>
          <Alert
            message={alertMessage.message}
            type={alertMessage.type}
            closeAlert={() => dispatch(closeAlertMessage())}
          />
        </div>
      )}
      {Information}
      {information.shipping_option === "delivery" && ShippingMethod}
      <NavigationFooter type="shipping" saveData={saveData} />
    </div>
  );
};

export default ShippingContent;
